
<template functional>
  <div class="skeletonShimmer__template">

    <div class="pulse">
      <div class="skeletonShimmer__circle"/>
      <div class="skeletonShimmer__paragraph"/>
      <div class="skeletonShimmer__paragraph"/>
      <div class="skeletonShimmer__paragraph"/>
      <div class="skeletonShimmer__span"/>
    </div>

    <div class="skeletonShimmer__buttons pulse">
      <div class="skeletonShimmer__button"/>
      <div class="skeletonShimmer__span"/>
    </div>

    <slot/>
  </div>
</template>

<script>
export default {
  name: 'SkeletonDefault',
};
</script>

<style lang="scss">
.skeletonShimmer__buttons {

  div:first-child {
    margin-bottom: 12px;
  }
}
</style>
